import React from 'react';
import '../../css/LearningHero.css';

const LearningHero = ({
  title = 'Learning Zone',
  subtitle = 'Learn faster with guided tutorials and practical examples.',
  searchQuery,
  onSearchQueryChange,
  onSearchSubmit,
  onClearSearch,
  onOpenBrowse,
  isSearching,
}) => {
  return (
    <section className="learning-hero">
      <div className="learning-hero__inner">
        <div className="learning-hero__text">
          <h3 className="ts-blog-hero-title">
            Stories & <span className="ts-gradient-text">Ideas</span>
          </h3>
          <p className="learning-hero__subtitle">{subtitle}</p>
        </div>

        <div className="learning-hero__actions">
          <form
            className="learning-hero__search"
            onSubmit={(e) => {
              e.preventDefault();
              onSearchSubmit?.();
            }}
          >
            <span className="learning-hero__searchIcon" aria-hidden="true">
              🔍
            </span>
            <input
              className="learning-hero__searchInput"
              value={searchQuery}
              onChange={(e) => onSearchQueryChange?.(e.target.value)}
              placeholder="Search tutorials..."
              type="search"
            />
            {searchQuery ? (
              <button
                className="learning-hero__clear"
                type="button"
                onClick={() => onClearSearch?.()}
                aria-label="Clear search"
              >
                ✕
              </button>
            ) : null}
            <button className="learning-hero__submit" type="submit">
              {isSearching ? 'Searching…' : 'Search'}
            </button>
          </form>

          <button
            className="learning-hero__browseBtn"
            type="button"
            onClick={() => onOpenBrowse?.()}
          >
            Browse lessons
          </button>
        </div>
      </div>
    </section>
  );
};

export default LearningHero;